import styled from 'styled-components';

import { BasicParagraph } from '../../../../../foundations/typefaces/BasicParagraph';

interface WrapperProps {
  $width?: string;
}

interface StyledInputProps {
  $width?: string;
  $disabled?: boolean;
  $multilinePlaceholder?: boolean;
}

const getCursorStyle = (disabled: boolean, focused?: boolean) => {
  if (disabled) {
    return 'not-allowed';
  }

  if (focused) {
    return 'text';
  }

  return 'auto';
};

export const Wrapper = styled.div<WrapperProps>(({ $width }) => ({
  width: $width || 'auto',
  flex: $width ? undefined : 1,
}));

export const StyledInvisibleInput = styled(BasicParagraph)<StyledInputProps>(
  ({
    theme: { size, color, font },
    $width,
    $disabled = false,
    $multilinePlaceholder = false,
  }) => ({
    width: $width || '100%',
    height: $multilinePlaceholder ? '100%' : size.units(3),
    color: $disabled
      ? color.content.secondary.disabled()
      : color.content.secondary.default(),
    WebkitTextFillColor: $disabled
      ? color.content.secondary.disabled()
      : color.content.secondary.default(),
    cursor: getCursorStyle($disabled),
    boxShadow: 'none',
    background: 'transparent',
    fontFamily: font.family,
    border: 0,
    padding: 0,
    resize: 'none',

    '&:focus': {
      border: 0,
      borderRadius: 0,
      outline: 0,
    },

    '::placeholder': {
      '-webkit-text-fill-color': $disabled
        ? color.content.secondary.disabled()
        : color.content.secondary.default(0.55),
    },

    // The following styles are needed to fix iOS Safari disabled state
    // https://stackoverflow.com/questions/262158/disabled-input-text-color-on-ios
    ':disabled, :disabled::placeholder': {
      opacity: 1,
      '-webkit-text-fill-color': color.content.secondary.disabled(),
    },
  }),
);
